import { Component, Input, ViewChild, QueryList, ElementRef, AfterViewInit, ContentChildren } from '@angular/core';

@Component({
    selector: 'tr-carousel',
    templateUrl: './tr-carousel.component.html',
    styleUrls: ['./tr-carousel.component.scss'],
})
export class TrCarouselComponent {
    @Input() public hideControlls: boolean = false;

    @ViewChild('carouselContainer', { static: false }) public containerRef?: ElementRef<HTMLDivElement>;

    @ContentChildren('slide')
    public slideElements: QueryList<ElementRef<HTMLDivElement>>;
    public currentSlide = 0;

    public ngAfterContentInit() {
        this.slideElements.forEach((element) => {
            element.nativeElement.setAttribute('style', 'flex: 0 0 auto; scroll-snap-align: center');
        });
    }

    get inTheLastSlide() {
        return this.slideElements.length - 2 === this.currentSlide;
    }

    get inTheFirstSlide() {
        return this.currentSlide === 0;
    }

    public nextSlide() {
        this.currentSlide = Math.min(this.slideElements.length - 2, this.currentSlide + 1);
        this.moveToCurrentSlide();
    }

    public prevSlide() {
        this.currentSlide = Math.max(0, this.currentSlide - 1);
        this.moveToCurrentSlide();
    }

    private moveToCurrentSlide() {
        const currentSlide = this.slideElements.toArray()[this.currentSlide] as ElementRef<HTMLDivElement>;

        if (currentSlide) {
            currentSlide.nativeElement.scrollIntoView({
                block: 'nearest',
                inline: 'start',
                behavior: 'smooth',
            });
        }
    }
}
